<div class="container">
  <div class="content-wrapper" #wrapper>
    <img class="logo" src="/assets/images/transend-logo-title.png" alt="Transend">

    <div class="title">Command Center Forgot Password</div>
    <div class="sub-title"></div>

    <app-form [formGroup]="forgotPasswordFormGroup" [formDefinition]="forgotPasswordFormDefinition"></app-form>

    <div class="form-actions" mat-dialog-actions>
      <button mat-flat-button color="accent" [disabled]="this.forgotPasswordFormGroup.invalid || isSubmitting" id="forgot-password-button" (click)="forgotPassword()">
        @if (!isSubmitting) {
          <span>Send</span>
        }
        @if (isSubmitting) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>